import { createContext } from 'react';

import {
  AwsHierarchyCostReport,
  AwsInstanceAction,
  AwsInstanceRecord,
  AwsInstanceRecords,
  AwsMonthlyCosts,
  AwsStatusCostReport,
  AwsSummary,
} from '@totem/components/administration/amazonWebServices/types';

const EMPTY_SUMMARY: AwsSummary = {
  totalInstances: 0,
  currentMonthCost: '0',
  previousMonthCost: '0',
  currency: 'USD',
};

const EMPTY_HIERARCHY_COST_REPORT: AwsHierarchyCostReport = {
  months: [],
  currency: 'USD',
  organizations: [],
};

const EMPTY_STATUS_COST_REPORT: AwsStatusCostReport = {
  months: [],
  currency: 'USD',
  statuses: [],
};

interface Context {
  loading: boolean;
  data: AwsInstanceRecords;
  summary: AwsSummary;
  monthlyCosts: AwsMonthlyCosts;
  hierarchyCostReport: AwsHierarchyCostReport;
  statusCostReport: AwsStatusCostReport;
  onRefresh: () => void;
  selectedInstance: AwsInstanceRecord | null;
  activeAction: AwsInstanceAction | null;
  onAction: (action: AwsInstanceAction, instance: AwsInstanceRecord) => void;
  onActionClose: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  summary: EMPTY_SUMMARY,
  monthlyCosts: [],
  hierarchyCostReport: EMPTY_HIERARCHY_COST_REPORT,
  statusCostReport: EMPTY_STATUS_COST_REPORT,
  onRefresh: () => {},
  selectedInstance: null,
  activeAction: null,
  onAction: () => {},
  onActionClose: () => {},
});
